import { render, staticRenderFns } from "./default.vue?vue&type=template&id=7492651e&scoped=true"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=7492651e&prod&scoped=true&lang=css"
import style1 from "./default.vue?vue&type=style&index=1&id=7492651e&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7492651e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DialogEmailRequired: require('/home/runner/work/trustpage/trustpage/components/DialogEmailRequired.vue').default,EditUi: require('/home/runner/work/trustpage/trustpage/components/editUi/EditUi.vue').default,DrawerNda: require('/home/runner/work/trustpage/trustpage/components/DrawerNda.vue').default,Footer: require('/home/runner/work/trustpage/trustpage/components/footer/Footer.vue').default})
